import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-energy-saver-banner',
  templateUrl: './energy-saver-banner.component.html',
  styleUrls: ['./energy-saver-banner.component.scss']
})
export class EnergySaverBannerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
